import { useTranslation } from 'react-i18next';
import type { ProjectStatus } from '../types/ProjectList';

const STATUS_LABEL_KEYS = {
  0: 'situacoes.emAndamento',
  1: 'situacoes.emContratacao',
  2: 'situacoes.cancelado',
  3: 'situacoes.encerrado',
  4: 'situacoes.emGarantia',
} as const satisfies Record<ProjectStatus, string>;

/** Situação desconhecida (código fora de 0–4) cai num rótulo próprio, como o legado. */
export function useProjectStatusLabel() {
  const { t } = useTranslation('projetos');
  return (status: number) =>
    t(
      status in STATUS_LABEL_KEYS
        ? STATUS_LABEL_KEYS[status as ProjectStatus]
        : 'situacoes.desconhecida',
    );
}
